import { useRef, useContext } from "react";
import ReactDOM from "react-dom";

import { MapPanelContext } from "./MapPanel";

const MapPanelActions = props => {
  const { children } = props;
  const elementRef = useRef();
  const { mapPanelActionsContainer } = useContext(MapPanelContext);

  if (!mapPanelActionsContainer) return null;

  return ReactDOM.createPortal(
    <div className="map-panel-actions box-shadow" ref={elementRef}>
      {children}
    </div>,
    mapPanelActionsContainer
  );
};

export default MapPanelActions;
